'use client'


export function FeaturesOverview() {
  return (
    <section>
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Features */}
          <div className="space-y-12">

          </div>
        </div>
      </div>
    </section>
  )
}
